<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
        <path fill="#0d5fc3" d="M35.1 20.6l-.8-.9c1.4-1.2 3.2-1.8 5-1.8v1.2c-1.5 0-3 .5-4.2 1.5z" />
        <path fill="#4de0f9" d="M33.8 23.6l-1.1-.5c.3-.6.6-1.2 1.1-1.8l.9.8c-.4.5-.7 1-.9 1.5z" />
        <path fill="#0d5fc3" d="M33.2 23.1l-1.1-.5c.3-.6.6-1.2 1.1-1.8l.9.8c-.4.5-.7 1-.9 1.5z" />
        <path fill="#4de0f9" d="M36.6 17.7c.3 0 .6-.1 1-.1h.7c-1.1-1.6-2.5-2.8-4.2-3.6 1 1.1 1.9 2.3 2.5 3.7zM42.9 19.9c1.3 1.3 2 3.1 2 5.1 0 1-.2 1.9-.5 2.8h-5.1v.4c0 .5.1 1 .2 1.4H47c.3-.9.5-1.8.5-2.8.1-3.2-1.9-5.9-4.6-6.9z" />
        <path fill="#0d5fc3" d="M46.5 29.2h-5.3V28h4.5c.2-.7.4-1.4.4-2.2 0-3.7-3-6.7-6.7-6.7-.3 0-.6 0-.9.1H38l-.2-.4c-1.6-3.7-5.1-6-9.1-6-4.9 0-9.1 3.7-9.8 8.5l-.1.5h-.5c-2.8.2-5 2.6-5 5.4 0 .3 0 .5.1.8h5v1.2h-6l-.1-.5c-.1-.5-.2-1-.2-1.6 0-3.3 2.4-6 5.6-6.5 1-5.2 5.6-9.1 10.9-9.1 4.3 0 8.2 2.5 10 6.3h.6c4.4 0 7.9 3.6 7.9 7.9 0 1-.2 2-.6 3v.5z" />
        <path fill="#0d5fc3" d="M4.4 28h11.3v1.2H4.4z" />
        <path fill="#0d5fc3" d="M8.3 24.7h4.8v1.2H8.3z" />
        <path fill="#0d5fc3" d="M12.1 21.4h3.6v1.2h-3.6z" />
        <path fill="#0d5fc3" d="M8.7 17.9h2.7v1.2H8.7z" />
        <path fill="#4de0f9" d="M30.7 35.5h9.5v2.3h-9.5z" />
        <path fill="#4de0f9" d="M37.7 28.5l2.5-1.6v10.9h-2.5z" />
        <path fill="#0d5fc3" d="M39.9 37.4H21.5V25.3h18.4v12.1zm-17.2-1.2h16v-9.7h-16v9.7z" />
        <path fill="#0d5fc3" d="M30.7 32.1l-8.9-5.7.6-1 8.3 5.3 8.3-5.3.6 1zM19.9 30.6h2.2v1.2h-2.2z" />
        <path fill="#0d5fc3" d="M16.5 33.4h5.6v1.2h-5.6z" />
        <path fill="#0d5fc3" d="M13.1 36.2h9v1.2h-9z" />
        <path fill="#0d5fc3" d="M15.8 14.5h1.6v1.2h-1.6z" />
    </svg>
</template>
<script>
// https://www.iconfinder.com/iconsets/message-and-communication-sets
export default {

};
</script>
